import SettlementPaymentsFieldLabel from "./SettlementPaymentsFieldLabel";

export default function SettlementPaymentsModalField({ className = "", label, renderValue }) {
  return (
    <div className={`flex w-full flex-col gap-1 ${className}`}>
      <SettlementPaymentsFieldLabel value={label} />
      {renderValue}
    </div>
  );
}

